import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface User {
  id: string
  email: string
  real_name: string
  user_type: string
}

interface AuthState {
  accessToken: string | null
  refreshToken: string | null
  user: User | null
  projectId: string | null
  setAuth: (accessToken: string, refreshToken: string, user: User) => void
  setProject: (projectId: string, accessToken: string) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      projectId: null,
      setAuth: (accessToken, refreshToken, user) =>
        set({ accessToken, refreshToken, user }),
      setProject: (projectId, accessToken) => set({ projectId, accessToken }),
      logout: () =>
        set({ accessToken: null, refreshToken: null, user: null, projectId: null }),
    }),
    { name: 'greatops-auth' }
  )
)
